import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { deleteproduct, getproduct } from "../redux-toolkit/Slice/productSlice";
import { DELETE_product, GET_product } from "../redux-toolkit/ApiEndpoint";



const ProductView = () => {
    // // State to manage active tab
    // const [activeTab, setActiveTab] = useState('tablets');

    // // Function to change active tab
    // const handleTabClick = (tabName) => {
    //     setActiveTab(tabName);
    // };

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleAddproductClick = () => {
        navigate('/add-product', {
            state: { title: "Add Product", label1: 'Product Name', placeholder1: 'Enter Product name', label2: 'Product Type Name', placeholder2: 'Select Product Type name', },
        });
    };

    const handleEditproduct = (item) => {
        navigate('/add-product', {
            state: { title: "Edit Product", label1: 'Edit Product Name', placeholder1: 'Enter Product name', label2: 'Edit Product Type Name', placeholder2: 'Select Product Type name', Editdata: item },
        }
        );
    };

    useEffect(() => {
        dispatch(getproduct({
            endpoint: GET_product
        }));
    }, [dispatch]);

    const { productdata } = useSelector((state) => state.product);
    // console.log(productdata, "productdataproductdataproductdata");

    const handleDeleteproduct = (item) => {
        // console.log(item);
        dispatch(deleteproduct({
            endpoint: DELETE_product,
            uuid: item.uuid
        })).unwrap()
            .then(() => {
                toast.success('Product  deleted successfully!');
            })
            .catch((error) => {
                toast.error(error || 'Failed to delete the Product .');
            });
    };

    return (
        <main className="page-padding">
            <ToastContainer />
            <section className="product-tab-wrapper">
                <div className="container-fuild">
                    <div className="row position-relative">
                        <div className="d-flex justify-content-between align-items-center flex-wrap ">
                            <h2 className="title">All Products List</h2>
                            {/* <Link className="btn-grad d-inline-flex align-items-center justify-content-center text-uppercase" to="/add-product">Add Product</Link> */}
                            <button className="btn-grad d-inline-flex align-items-center justify-content-center text-uppercase border border-0" onClick={handleAddproductClick}>
                                Add Product
                            </button>
                        </div>
                        <div className="col-12">
                            <hr />
                        </div>
                        <div className="col-lg-12">
                            <div className="right-tab" data-aos="fade-in" data-aos-duration="3000">
                                <div className="product-content table-responsive">
                                    {/* <h4 className="product-heading-small">Tablets & Capsules List</h4> */}
                                    <table className="table table-bordered pro-table w-100">
                                        <thead>
                                            <tr>
                                                <th>sr</th>
                                                <th>Drug Dose Form</th>
                                                <th>Correct Generic Name </th>
                                                <th>Edit/Delete</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {productdata && productdata.length > 0 ? productdata.map((item, index) => {
                                                return (
                                                    <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>{item?.productType?.typename}</td>
                                                        <td>{item?.productname}</td>
                                                        <td>
                                                            <div className="d-flex">
                                                                <button className="edit-btn border border-0" onClick={() => handleEditproduct(item)}>Edit</button>
                                                                <button className="delete-btn border border-0" onClick={() => handleDeleteproduct(item)}>Delete</button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                );
                                            }) : (
                                                <tr>
                                                    <td colSpan="3" className="text-center">No Product available</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <div className="modal fade" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header border-0">
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body border-0">
                            <h3 className="text-center">Want to Delete this Product</h3>
                        </div>
                        <div className="modal-footer border-0 justify-content-center">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                            <button type="button" className="btn edit-btn">Yes</button>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default ProductView;
